import React from "react";
import ProductModalWrapper from "components/MainApp/organisms/Product/Modals/ProductModalWrapper";

import styles from "./ErrorModalAuditory.module.scss";
import i18n from "i18n";
export class ErrorModal extends React.Component {
  render() {
    const {
      open,
      message,
      handleClose,
      handleGoBack,
      handleButtonClick, //Buscar nuevamente
    } = this.props;

    const content = (
      <div className={styles["wrong-content-modal-wrapper"]}>
        <div className={styles["wrong-content-modal-title"]}>{i18n.t("error")}</div>
        <div className={styles["wrong-content-modal-text"]}>{message}</div>
      </div>
    );

    const footer = (
      <div className={styles["product-modal-wrapper-footer"]}>
        {i18n.t("update.search")}
      </div>
    );
    return (
      <div className={styles["wrong-content-modal-container"]}>
        <ProductModalWrapper
          open={open}
          innerContent={content}
          buttonLegend={i18n.t("accept")}
          handleGoBack={handleGoBack}
          handleClose={handleClose}
          handleButtonClick={handleButtonClick}
          footer={footer}
        ></ProductModalWrapper>
      </div>
    );
  }
}

ErrorModal.propTypes = {};

export default ErrorModal;
